(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sinestesia-aura')) return;

    const parseRGB = (str, fb) => {
      const m = (str || '').match(/[\d.]+/g);
      return m && m.length >= 3 ? [+m[0], +m[1], +m[2]] : fb;
    };
    const rgba = (c, a) => `rgba(${c[0] | 0},${c[1] | 0},${c[2] | 0},${a})`;

    class SinestesiaAura extends HTMLElement {
      connectedCallback() {
        if (this._alive) return;
        this._alive = true;
        this._init();
      }

      disconnectedCallback() {
        this._destroy();
      }

      _init() {
        const d = this.dataset;
        this.canvas = this.querySelector('canvas');
        if (!this.canvas) return;
        this.ctx = this.canvas.getContext('2d');

        if (matchMedia('(hover: none), (pointer: coarse)').matches && d.mobile !== 'true') {
          this.style.display = 'none';
          return;
        }

        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.trail = d.trail === 'true';
        this.ambient = d.ambient === 'true';
        this.pulseOn = d.pulse === 'true';

        const size = parseFloat(d.size) || 340;
        const speed = Math.min(10, Math.max(1, parseFloat(d.speed) || 5));
        const c1 = parseRGB(d.c1, [201, 167, 232]);
        const c2 = parseRGB(d.c2, [244, 185, 161]);
        const c3 = parseRGB(d.c3, [169, 211, 192]);
        const k = 0.012 + speed * 0.007;

        this.RES = 0.5;
        this.blobs = [
          { c: c1, r: size * 0.42, k: k * 1.9,  damp: 0.72, a: 0.95, amp: 0.18, f: [0.00031, 0.00043], ph: 0 },
          { c: c1, r: size,        k: k,        damp: 0.82, a: 0.75, amp: 0.34, f: [0.00017, 0.00023], ph: 1.3 },
          { c: c2, r: size * 0.9,  k: k * 0.62, damp: 0.86, a: 0.7,  amp: 0.3,  f: [0.00013, 0.00019], ph: 2.6 },
          { c: c3, r: size * 1.1,  k: k * 0.4,  damp: 0.89, a: 0.65, amp: 0.36, f: [0.00011, 0.00015], ph: 4.1 }
        ].map((b) => ({ ...b, x: 0, y: 0, vx: 0, vy: 0 }));

        this.pointer = { cx: -9999, cy: -9999, has: false, type: 'mouse' };
        this.pulse = 0;
        this.visible = true;

        this._frame = this._frame.bind(this);
        this._resize = this._resize.bind(this);
        this._toggle = this._toggle.bind(this);

        this._onMove = (e) => {
          this.pointer.cx = e.clientX;
          this.pointer.cy = e.clientY;
          this.pointer.has = true;
          this.pointer.type = e.pointerType || 'mouse';
          if (this.pointer.type !== 'mouse') this._touchUntil = performance.now() + 1400;
        };
        this._onDown = (e) => {
          this._onMove(e);
          if (!this.pulseOn) return;
          const r = this.getBoundingClientRect();
          if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) this.pulse = 1;
        };
        this._onOut = (e) => {
          if (!e.relatedTarget) this.pointer.has = false;
        };

        window.addEventListener('pointermove', this._onMove, { passive: true });
        window.addEventListener('pointerdown', this._onDown, { passive: true });
        document.addEventListener('pointerout', this._onOut, { passive: true });
        document.addEventListener('visibilitychange', this._toggle);

        this.ro = new ResizeObserver(this._resize);
        this.ro.observe(this);
        this.io = new IntersectionObserver(
          ([en]) => {
            this.visible = en.isIntersecting;
            this._toggle();
          },
          { rootMargin: '120px' }
        );
        this.io.observe(this);

        this._resize();
        this._draw(performance.now(), true);
        if (this.reduced) this.classList.add('is-ready');
        else this._toggle();
      }

      _resize() {
        const r = this.canvas.getBoundingClientRect();
        this.w = Math.max(1, r.width);
        this.h = Math.max(1, r.height);
        this.canvas.width = Math.ceil(this.w * this.RES);
        this.canvas.height = Math.ceil(this.h * this.RES);
        if (this.reduced || !this.raf) this._draw(performance.now(), true);
      }

      _toggle() {
        const run = this.visible && !document.hidden && !this.reduced;
        if (run && !this.raf) {
          this.raf = requestAnimationFrame(this._frame);
        } else if (!run && this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }

      _frame(now) {
        this.raf = requestAnimationFrame(this._frame);
        this._draw(now, false);
        if (!this.classList.contains('is-ready')) this.classList.add('is-ready');
      }

      _draw(now, still) {
        const { ctx, canvas, w, h, RES, pointer } = this;
        if (!ctx || !w) return;

        const rect = canvas.getBoundingClientRect();
        const lx = pointer.cx - rect.left;
        const ly = pointer.cy - rect.top;
        const inside = pointer.has && lx >= 0 && ly >= 0 && lx <= rect.width && ly <= rect.height;
        const live = pointer.type === 'mouse' || (this._touchUntil && now < this._touchUntil);
        const active = inside && live;

        this.blobs.forEach((b, i) => {
          let tx, ty;
          if (active) {
            const orbit = i ? b.r * 0.18 : 0;
            tx = lx + Math.sin(now * 0.0011 + b.ph) * orbit;
            ty = ly + Math.cos(now * 0.0013 + b.ph) * orbit;
          } else if (this.ambient || still) {
            tx = w / 2 + Math.sin(now * b.f[0] + b.ph) * w * b.amp;
            ty = h / 2 + Math.cos(now * b.f[1] + b.ph * 1.7) * h * b.amp * 0.9;
          } else {
            tx = b.x;
            ty = b.y;
          }

          if (still) {
            b.x = tx;
            b.y = ty;
            b.vx = b.vy = 0;
          } else {
            const kk = active ? b.k : b.k * 0.35;
            b.vx = (b.vx + (tx - b.x) * kk) * b.damp;
            b.vy = (b.vy + (ty - b.y) * kk) * b.damp;
            b.x += b.vx;
            b.y += b.vy;
          }
        });

        const useTrail = this.trail && !still;
        if (useTrail) {
          ctx.globalCompositeOperation = 'destination-out';
          ctx.fillStyle = 'rgba(0,0,0,0.14)';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.globalCompositeOperation = 'source-over';
        } else {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }

        this.blobs.forEach((b, i) => {
          const breathe = 1 + Math.sin(now * 0.0012 + b.ph) * 0.07;
          const vel = Math.min(1, Math.hypot(b.vx, b.vy) / 40);
          let r = b.r * breathe * (1 + vel * 0.25);
          if (i === 0) r *= 1 + this.pulse * 0.9;

          const R = r * RES;
          const a = b.a * (useTrail ? 0.22 : 1);

          ctx.save();
          ctx.translate(b.x * RES, b.y * RES);
          ctx.rotate(Math.atan2(b.vy, b.vx));
          ctx.scale(1 + vel * 0.35, 1 - vel * 0.2);
          const g = ctx.createRadialGradient(0, 0, 0, 0, 0, R);
          g.addColorStop(0, rgba(b.c, a));
          g.addColorStop(0.45, rgba(b.c, a * 0.45));
          g.addColorStop(1, rgba(b.c, 0));
          ctx.fillStyle = g;
          ctx.beginPath();
          ctx.arc(0, 0, R, 0, Math.PI * 2);
          ctx.fill();
          ctx.restore();
        });

        this.pulse *= 0.93;
        if (this.pulse < 0.001) this.pulse = 0;
      }

      _destroy() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        if (this._onMove) {
          window.removeEventListener('pointermove', this._onMove);
          window.removeEventListener('pointerdown', this._onDown);
          document.removeEventListener('pointerout', this._onOut);
          document.removeEventListener('visibilitychange', this._toggle);
        }
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        this._alive = false;
      }
    }

    customElements.define('sinestesia-aura', SinestesiaAura);
  })();

  } catch(e) { console.error(e); }
})();
})();
